import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c092966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-stores__body" }
const _hoisted_2 = { class: "uf-stores__info" }
const _hoisted_3 = { class: "uf-remarks-result" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "uf-result__content-other"
}
const _hoisted_6 = { style: {"margin":"0 15px"} }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "uf-button" }
const _hoisted_9 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_uf_form = _resolveComponent("uf-form")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.innerShow,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.innerShow) = $event)),
    position: "right",
    style: { height: '100%', width: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_nav_bar, {
          title: "备注",
          "left-text": "返回",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.innerShow = false))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_uf_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_uf_form_item, {
                title: "备注结果",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fireResult, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "uf-remarks-result__item",
                        key: item.id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["uf-result__content", { active: _ctx.state.close_result_one === item.id, 'uf-result__content--red': item.id === '1' }]),
                          onClick: ($event: any) => (_ctx.state.close_result_one = item.id)
                        }, _toDisplayString(item.name), 11, _hoisted_4)
                      ]))
                    }), 128))
                  ]),
                  (_ctx.state.close_result_one === '100')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_van_field, {
                          modelValue: _ctx.state.result_desc,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.result_desc) = $event)),
                          placeholder: "请输入备注结果"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_uf_form_item, { title: "图片" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_van_uploader, {
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.files) = $event)),
                      "max-count": 3,
                      "max-size": 20 * 1024 * 1024,
                      "preview-size": "105",
                      "image-fit": "contain",
                      "after-read": _ctx.upload
                    }, null, 8, ["modelValue", "after-read"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_uf_form_item, { title: "备注" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_van_field, {
                      modelValue: _ctx.state.opt_content,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.opt_content) = $event)),
                      rows: "4",
                      "show-word-limit": "",
                      maxlength: 200,
                      autosize: "",
                      type: "textarea",
                      placeholder: "请输入评价内容"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_button, {
              class: "btn",
              block: "",
              color: "#3d6eeb",
              square: "",
              type: "success",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}